/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Severity level for findings produced by this rule.
 */
export const UpdateCustomDetectionRuleRequestBodySeverity = {
  Info: "info",
  Low: "low",
  Medium: "medium",
  High: "high",
  Critical: "critical",
} as const;
/**
 * Severity level for findings produced by this rule.
 */
export type UpdateCustomDetectionRuleRequestBodySeverity = ClosedEnum<
  typeof UpdateCustomDetectionRuleRequestBodySeverity
>;

export type UpdateCustomDetectionRuleRequestBody = {
  /**
   * Description of what the rule detects.
   */
  description?: string | undefined;
  /**
   * CEL detection predicate: a boolean expression over message fields whose true verdict produces a finding.
   */
  detectionExpr?: string | undefined;
  /**
   * The custom detection rule ID.
   */
  id: string;
  /**
   * Deprecated legacy RE2 regex pattern; superseded by detection_expr. Accepted for backward compatibility.
   */
  regex?: string | undefined;
  /**
   * Severity level for findings produced by this rule.
   */
  severity: UpdateCustomDetectionRuleRequestBodySeverity;
  /**
   * Human-readable title for the rule.
   */
  title: string;
};

/** @internal */
export const UpdateCustomDetectionRuleRequestBodySeverity$outboundSchema:
  z.ZodMiniEnum<typeof UpdateCustomDetectionRuleRequestBodySeverity> = z.enum(
    UpdateCustomDetectionRuleRequestBodySeverity,
  );

/** @internal */
export type UpdateCustomDetectionRuleRequestBody$Outbound = {
  description?: string | undefined;
  detection_expr?: string | undefined;
  id: string;
  regex?: string | undefined;
  severity: string;
  title: string;
};

/** @internal */
export const UpdateCustomDetectionRuleRequestBody$outboundSchema: z.ZodMiniType<
  UpdateCustomDetectionRuleRequestBody$Outbound,
  UpdateCustomDetectionRuleRequestBody
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    detectionExpr: z.optional(z.string()),
    id: z.string(),
    regex: z.optional(z.string()),
    severity: UpdateCustomDetectionRuleRequestBodySeverity$outboundSchema,
    title: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      detectionExpr: "detection_expr",
    });
  }),
);

export function updateCustomDetectionRuleRequestBodyToJSON(
  updateCustomDetectionRuleRequestBody: UpdateCustomDetectionRuleRequestBody,
): string {
  return JSON.stringify(
    UpdateCustomDetectionRuleRequestBody$outboundSchema.parse(
      updateCustomDetectionRuleRequestBody,
    ),
  );
}
